import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReporting = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_50_793)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7.7097 16.8857H2.7478C2.4188 16.8857 2.10328 16.755 1.87065 16.5224C1.63802 16.2897 1.50732 15.9742 1.50732 15.6452V3.24047C1.50732 2.91148 1.63802 2.59596 1.87065 2.36333C2.10328 2.13069 2.4188 2 2.7478 2H16.393C16.722 2 17.0375 2.13069 17.2702 2.36333C17.5028 2.59596 17.6335 2.91148 17.6335 3.24047V9.44285",
				stroke: "#B4B8BC",
				strokeWidth: 1.13996,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.50732 5.7215H17.6335",
				stroke: "#B4B8BC",
				strokeWidth: 1.13996,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6715 16.2655C14.3842 16.2655 15.7727 14.877 15.7727 13.1643C15.7727 11.4516 14.3842 10.0631 12.6715 10.0631C10.9588 10.0631 9.57031 11.4516 9.57031 13.1643C9.57031 14.877 10.9588 16.2655 12.6715 16.2655Z",
				stroke: "#B4B8BC",
				strokeWidth: 1.13996,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.8672 15.36L17.6334 18.1263",
				stroke: "#B4B8BC",
				strokeWidth: 1.13996,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_50_793",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18.574,
			height: 18.574,
			fill: "white",
			transform: "translate(0.283203 0.215576)"
		})
	}) })]
});
export default SvgReporting;
